export default "skymp5-front/ddc9de6f6d12b10ce98a88b4b5f0002d.png";